export function loadNextTimelineEntries() {
    page = page + 1;
    pageCount = pageCount + 1;
    $.ajax({
        type: "POST",
        url: "/module/community/ajax.php?action=load_next_timeline_entries",
        datatype: "json",
        data: {
            "ajax_call_page": page,
            "ajax_call_user_id": shopUserId,
            "ajax_call_type": activeMenuPoint
        },
        success: function (output) {
            $(".timeline_entry").last().after(output);
        }
    });
}


